<template>
  <div class="medical-detail-cntainer">
    <TopBg
      :title="title"
      :sub-title="subTitle"
      :bg="topBg"
    />
    <div class="main-content page">
      <!-- 产品简介 -->
      <div class="section">
        <div class="title">产品简介</div>
        <div class="disc">
          基于医院线下就医流程，结合互联网技术应用，为患者提供更加便捷得线上线下一体化“互联网+医疗健康”服务。
        </div>
        <div class="rows-2">
          <info-item-vue
            title="产品背景"
            desc="在政策支持与技术发展的双重驱动下，医疗行业正加速向智慧化转型。国家推动线上诊疗、医保支付及电子病历互联等改革，为互联网医疗提供坚实基础。5G、AI等技术的成熟，助力实现远程医疗、复诊开方与健康管理的一体化服务。用户需求从“以治疗为中心”向“全生命周期健康管理”升级，进一步催化互联网医院发展。"
          >
            <template #icon>
              <img src="../../../assets/bj.svg" alt="" />
            </template>
          </info-item-vue>
          <info-item-vue
            title="产品概述"
            desc="互联网医院平台深度融合院内系统，集成智慧门诊、住院、线上诊疗、处方流转、健康管理及便民预约等服务，覆盖患者就医全流程，实现线上线下一体化服务模式，高度符合国家智慧服务评审要求。"
          >
            <template #icon>
              <img src="../../../assets/gs.svg" alt="" />
            </template>
          </info-item-vue>
        </div>
      </div>
      <!-- 解决方案 -->
      <div class="section">
        <div class="title">痛点分析</div>
        <div class="rows-3">
          <PainsAnalysisItem
            title="患者"
            desc="传统流程繁琐，候诊时间长；跨区域复诊奔波频繁；慢性病管理缺乏专业指导。"
          >
            <template #icon>
              <img src="./assets/pains-analysis01.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem
            title="医院"
            desc="线下服务压力大；专家资源被常见病占用；设备利用不足；数据孤岛阻碍精细化运营。"
          >
            <template #icon>
              <img src="./assets/pains-analysis02.svg" alt="" />
            </template>
          </PainsAnalysisItem>
          <PainsAnalysisItem
            title="体系"
            desc="基层医疗资源空置，优质资源过度集中；分级诊疗因协作缺失难以落地，导致资源浪费。"
          >
            <template #icon>
              <img src="./assets/pains-analysis03.svg" alt="" />
            </template>
          </PainsAnalysisItem>
        </div>
      </div>

      <!-- 产品价值 -->
      <div class="section">
        <div class="title">产品价值</div>
        <div class="rows-3">
          <value-item-vue
            title="提升医疗服务可及性"
            desc="支持线上复诊、处方流转与药品配送，减少患者奔波，助力优质医疗资源下沉。"
          >
            <template #icon>
              <img src="./assets/value01.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="优化资源配置效率"
            desc="通过远程会诊与分级协作，激活基层资源，智能分诊提升专家利用效率。"
          >
            <template #icon>
              <img src="./assets/value02.svg" alt="" />
            </template>
          </value-item-vue>
          <value-item-vue
            title="强化医疗连续性"
            desc="打通电子病历跨机构调阅，构建“问诊-干预-随访”全周期健康管理服务。"
          >
            <template #icon>
              <img src="./assets/value03.svg" alt="" />
            </template>
          </value-item-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBg from "../../common/TopBg.vue";
import infoItemVue from "../../common/info-item.vue";
import valueItemVue from "../../common/value-item.vue";
import PainsAnalysisItem from "../../common/pains-analysis-item.vue";

export default {
  name: "InternetHospital",
  components: {
    TopBg,
    infoItemVue,
    valueItemVue,
    PainsAnalysisItem,
  },
  data() {
    return {
      topBg: require("./assets/bg.png"),
      title: "互联网医院平台",
      subTitle: "就医流程优化再造，提供线上线下一体化服务。",
    };
  },
  mounted() {
    // 判断是否为移动设备
    const isMobile = window.innerWidth < 1300;
    if(isMobile) {
      this.subTitle = "就医流程优化再造，<br>提供线上线下一体化服务。";
    }else{
      this.subTitle = "就医流程优化再造，提供线上线下一体化服务。";
    }
  },
};
</script>
